import api from "../../utils/axios-util";
import * as mutation_type from "../mutation-types";
const mutations = {
    [mutation_type.CommitNothing]: () => { }
};
const actions = {
    CreatetimeRule: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .post(`/timeRule/create`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    GettimeRule: ({ commit },query) => {
        return new Promise((resolve, reject) => {
            try {
                let skiptake =''
                if(query !== undefined){
                    skiptake = `?skip=${query.skip}&take=${query.take}&active=${query.active}&rule_name=${query.rule_name}`
                }
                api.get(`/timeRule/fetch${skiptake}`).then(response => {
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    
    deletetimeRule: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .delete(`/timeRule/delete/${payload}`)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing, {});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    UpdatatimeRule: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            console.log(payload,"kkkkkkkdfdfkkkkkkkkkkk")
            try {
                let innerpayload={...payload}
                const id = innerpayload.id;
                delete innerpayload.id;
                api
                    .put(`/timeRule/update/${id}`, innerpayload)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing, {});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    }
};
export default {
    mutations,
    actions
};